<ejs-dialog
	#modal
	(close)="closeModal()"
	cssClass="modal-md"
	[attr.data-test-id]="'addAdhocItemModal'">
	<ng-template #header>
		<div class="dlg-template">Add Adhoc Item</div>
	</ng-template>
	<ng-template #content>
		<form
			#templateForm="ngForm"
			(ngSubmit)="save()"
			[formGroup]="componentForm">
			@if (componentForm.invalid && templateForm.submitted) {
				<gandalf-lib-validation-messages
					[form]="componentForm"
					[requestObj]="addAdhocItemRequest"
					[attr.data-test-id]="'addAdhocItemModalValidationMessages'">
				</gandalf-lib-validation-messages>
			}
			<div class="row mb-3">
				<label class="col-lg-3 col-form-label required" for="postDate">Post Date</label>
				<div class="col-lg-9">
					<ejs-datepicker
						class="e-input"
						formControlName="postDate"
						id="postDate"
						[format]="dateFormat"
						placeholder="mm/dd/yyyy"
						[attr.data-test-id]="'addAdhocItemModalPostDateInput'">
					</ejs-datepicker>
				</div>
			</div>
			<div class="row mb-3">
				<label for="code" class="col-lg-3 col-form-label">Code</label>
				<div class="col-lg-9">
					<input id="code" type="text" class="e-input" formControlName="code"/>
				</div>
			</div>
			<div class="row mb-3">
				<label for="description" class="col-lg-3 col-form-label required">Description</label>
				<div class="col-lg-9">
					<input id="description" type="text" class="e-input" formControlName="description"/>
				</div>
			</div>
			<div class="row mb-3">
				<label for="quantity" class="col-lg-3 col-form-label required">Quantity</label>
				<div class="col-lg-9">
					<input id="quantity" type="text" class="e-input" formControlName="quantity" revDigitOnlyInput/>
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'addAdhocItemModalUnitPriceLabelGroup'">
				<label for="unitPrice" class="col-lg-3 col-form-label required">Unit Price</label>
				<div class="col-lg-9">
					<pms-always-set-currency-input
						htmlId="unitPrice"
						formControlName="unitPrice"
						min="0">
					</pms-always-set-currency-input>
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'addAdhocItemModalSubTotalLabelGroup'">
				<label for="subTotal" class="col-lg-3 col-form-label">Sub-Total</label>
				<div class="col-lg-9">
					<p class="form-control-static" id="subTotal">${{ subTotalString }}</p>
				</div>
			</div>
			<div class="row mb-3">
				<label for="TaxRate" class="col-lg-3 col-form-label" [attr.data-test-id]="'addAdhocItemModalTaxRateLabel'">Tax Rate</label>
				<div class="col-md-9">
					<ejs-dropdownlist
						id="TaxRate"
						[dataSource]="locationTaxList"
						formControlName="taxId"
						[showClearButton]="true"
						placeholder="Select Tax Rate">
					</ejs-dropdownlist>
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'addAdhocItemModalTotalLabelGroup'">
				<label for="total" class="col-lg-3 col-form-label">Total</label>
				<div class="col-lg-9">
					<p class="form-control-static" id="total">${{ totalString }}</p>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template #footerTemplate>
		<button ejs-button iconCss="fa fa-times" (click)="closeModal()" [attr.data-test-id]="'addAdhocItemModalCancelButton'">Cancel</button>
		<button
			type="button"
			ejs-button
			[isPrimary]="true"
			(click)="submitForm($event)"
			[attr.data-test-id]="'addAdhocSaveButton'">Save
		</button>
	</ng-template>
</ejs-dialog>
